if (!customElements.get('birthday-date-picker')) {
  customElements.define(
    'birthday-date-picker',
    class BirthdayDatePicker extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        try {
          this.handles = JSON.parse(this.dataset.handles || '{}');
        } catch (e) {
          this.handles = {};
        }

        this.activeSeries = this.dataset.activeSeries || 'fragrance';

        this.monthEl = this.querySelector('[data-month]');
        this.dayEl = this.querySelector('[data-day]');
        this.btn = this.querySelector('[data-submit]');
        this.errorEl = this.querySelector('[data-error]');
        this.tabs = this.querySelectorAll('[data-series]');

        if (!this.monthEl || !this.dayEl || !this.btn) return;

        this.dayPlaceholder = this.dayEl.options[0]?.text || '日を選択';
        this.maxDay = 31;

        this.monthEl.addEventListener('change', () => this.onMonthChange());
        this.btn.addEventListener('click', () => this.onSubmit());

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.setActiveSeries(tab.dataset.series));
        });
      }

      setActiveSeries(series) {
        if (!series || series === this.activeSeries) return;
        this.activeSeries = series;
        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.series === series;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        this.hideError();
      }

      daysInMonth(month) {
        return [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1] || 31;
      }

      onMonthChange() {
        const m = parseInt(this.monthEl.value, 10);
        const max = m ? this.daysInMonth(m) : 31;
        if (max === this.maxDay) return;
        this.maxDay = max;

        const currentDay = parseInt(this.dayEl.value, 10);
        this.dayEl.innerHTML = '';
        const placeholderOpt = document.createElement('option');
        placeholderOpt.value = '';
        placeholderOpt.textContent = this.dayPlaceholder;
        this.dayEl.appendChild(placeholderOpt);
        for (let d = 1; d <= max; d++) {
          const opt = document.createElement('option');
          opt.value = String(d);
          opt.textContent = `${d}日`;
          this.dayEl.appendChild(opt);
        }
        if (currentDay && currentDay <= max) {
          this.dayEl.value = String(currentDay);
        }
      }

      resolveHandle(month) {
        // 新構造: this.handles = { fragrance: {1: ...}, "essence-mist": {1: ...} }
        if (this.handles && this.handles[this.activeSeries]) {
          return this.handles[this.activeSeries][month];
        }
        // 旧構造（後方互換）: this.handles = { 1: ..., 2: ... }
        return this.handles[month];
      }

      async onSubmit() {
        this.hideError();
        const m = parseInt(this.monthEl.value, 10);
        const d = parseInt(this.dayEl.value, 10);
        if (!m || !d) {
          this.showError();
          return;
        }
        const handle = this.resolveHandle(m);
        if (!handle) {
          this.showError();
          return;
        }
        const baseUrl = `/products/${handle}`;
        this.btn.setAttribute('disabled', 'disabled');
        try {
          const res = await fetch(`${baseUrl}.js`, { headers: { Accept: 'application/json' } });
          if (!res.ok) throw new Error('product fetch failed');
          const product = await res.json();
          const target = `${m}月${d}日`;
          const variant = (product.variants || []).find((v) => v.option1 === target);
          window.location.href = variant ? `${baseUrl}?variant=${variant.id}` : baseUrl;
        } catch (e) {
          window.location.href = baseUrl;
        }
      }

      showError() {
        if (this.errorEl) this.errorEl.hidden = false;
      }

      hideError() {
        if (this.errorEl) this.errorEl.hidden = true;
      }
    }
  );
}
